export default __webpack_public_path__ + "static/uikit-1-577eafaf328723514a374f6c80f6ecfb.png";